import React from 'react';
import reqwest from 'reqwest';
import swal from 'sweetalert';

import settings from '../../../../../../settings';

import RightSide from '../../../../../components/FormArea/RightSide';
import Loader from '../../../../../components/Loader';
import Form from '../../../../../components/Form';
import Button from '../../../../../components/Button';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Input from '../../../../../components/Inputs/Input';
import Datepicker from '../../../../../components/Inputs/Datepicker';
import { faTrash, faTimes, faSave } from '@fortawesome/pro-solid-svg-icons';
import DataContainer from '../../../../../logic/dataContainer';

class RetirementDetails extends React.Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(new RegExp(`/${props.match.params.id}$`), '');

    this.state = {
      loading: true,
    };

    const retirementPromise = reqwest({
      method: 'GET',
      url: settings.office.retirement.get,
      contentType: 'JSON',
      data: {
        Token: localStorage.getItem('token'),
        Guid: props.match.params.id,
      },
    }).then(retirementResponse => {
      this.container = new DataContainer(retirementResponse);
    });

    Promise.all([retirementPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Überprüfung fehlgeschlagen!',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben.',
      });
      return;
    }

    const newRetirement = this.container.getStringified();

    reqwest({
      method: 'POST',
      url: settings.office.retirement.save,
      data: {
        Token: localStorage.getItem('token'),
        RetirementData: newRetirement,
      },
    }).then(() => {
      swal({
        title: 'Erfolgreich!',
        text: 'Ihre Ausbuchung wurde erfolgreich gespeichert.',
        icon: 'success',
      });
      this.props.history.replace(this.parentRoute);
    });
  };

  delete = () => {
    swal({
      title: 'Sind Sie sich sicher?',
      text: 'Möchten Sie diese Ausbuchung wirklich löschen?',
      icon: 'warning',
      buttons: ['Abbrechen', 'Löschen'],
      dangerMode: true,
    }).then(willDelete => {
      if (willDelete) {
        reqwest({
          method: 'GET',
          url: settings.office.retirement.delete,
          data: {
            Guid: this.container.get('Basic', 'Guid'),
          },
        }).then(() => {
          swal({
            title: 'Erfolgreich!',
            text: 'Ihre Ausbuchung wurde erfolgreich gelöscht.',
            icon: 'success',
          });
          this.props.history.replace(this.parentRoute);
        });
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <Form ref={node => (this.form = node)}>
            <ContentBox title='Ausbuchung'>
              <Datepicker
                label='Datum:'
                defaultValue={this.container.get('Generals', 'Date')}
                onChange={day => {
                  this.container.set('Generals', 'Date')(day);
                }}
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                name='Date'
              />
              {/* TODO: Add Dropdown of Employees*/}
              <Input
                type='text'
                label='Mitarbeiter:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                onChange={value => {
                  this.container.set('Generals', 'Employee')(value);
                }}
                defaultValue={this.container.get('Generals', 'Employee')}
                name='Mitarbeiter'
              />
              <Input
                type='text'
                label='Betrag:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                onChange={value => {
                  this.container.set('Generals', 'Amount')(value);
                }}
                defaultValue={this.container.get('Generals', 'Amount')}
                name='Betrag'
              />
              <Input
                type='textarea'
                label='Bemerkung:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                onChange={value => {
                  this.container.set('Generals', 'Commit')(value);
                }}
                defaultValue={this.container.get('Generals', 'Commit')}
                name='Bemerkung'
              />
            </ContentBox>
          </Form>
        </div>
        <RightSide
          createDate={this.container.get('RightSide', 'CreateDate')}
          createUserName={this.container.get('RightSide', 'CreateUserName')}
          updateDate={this.container.get('RightSide', 'UpdateDate')}
          updateUserName={this.container.get('RightSide', 'UpdateUserName')}
        >
          <Button big type='danger' icon={faTrash} onClick={this.delete}>
            Löschen
          </Button>
          <Button big icon={faTimes} to={this.parentRoute}>
            Abbrechen
          </Button>
          <Button big type='primary' icon={faSave} onClick={this.save}>
            Speichern
          </Button>
        </RightSide>
      </>
    );
  }
}

export default RetirementDetails;
